/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import noteReadView from '../paper-note-read-view';
import paperCitationPopup from '../paper-citation-popup';
import pdfViewer from '../pdf-viewer';
import ppLeftSidebar from '../paperpile-left-sidebar';
import toast from '@/services/toast';

export default {
  name: 'research-group-list',
  components: {
    'pp-left-sidebar' : ppLeftSidebar,
    'pdf-viewer' : pdfViewer,
    'note-read-view' : noteReadView,
    'paper-citation-popup' : paperCitationPopup
  },
  props: [],
  data () {
    return {
      researchGroupDetails:null,
      researchGroupInPapers:[],
      pdfViewerPopup:false,
      pdfViewerUrl:'',
      pdfId:'',
      pdfViewerFileName:'',
      citationPopupState:false,
      citationPaperId:'',
      notesViewPopupState:false,
      notesViewData:null,
      pdf_is_fav:Boolean,
    }
  },
  computed: {
    ...mapGetters([
      'getResearchGroupDetailByIdGetters',
    ]),
    getResearchGroupDetails(){
      this.researchGroupDetails = this.$store.getters.getResearchGroupDetailByIdGetters.data;
      return;
    },
    setInitialsState(){
      if(this.researchGroupDetails){
        this.researchGroupInPapers = this.researchGroupDetails.pdf_papers
      }
      return;
    }
  },
  mounted () {
    this.getResearchGroupDetails
    this.setInitialsState
    bus.$on('pdfViewerPopupBus', (data) => {
      this.pdfViewerPopup = data;
    });
    bus.$on('paperCitationPopupStateBus', (data) => {
      this.citationPopupState = data;
    });
    bus.$on('notesViewPopupStateBus', (data) => {
      this.notesViewPopupState = data;
    });
  },
  methods: {
    getPapersByIdAgain(){
    this.$store.dispatch('getResearchGroupDetailsByIDFun', {id:this.$route.params.researchGId})
    },
    favOfPaperMethod(isFav, paperId){
      if(isFav == true){
        this.pdf_is_fav = false
      }else{
        this.pdf_is_fav = true
      }
      let data = {
        is_favourite : this.pdf_is_fav
      }
      this.$store.dispatch('updatePaperPileDetailsByIdFun', {data:{id:paperId,data:data}})
        .then((res) => {  
          toast.success(res.data.msg);
          this.getPapersByIdAgain()
        }).catch((err) => {
          toast.error(err.data.user_msg || err.data.msg);
      })
    },
    citationPopupOpenMethod(Id){
      this.citationPaperId = Id
      this.citationPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    pdfViewerFun(url, fileName, Id){
      this.pdfId = Id
      this.pdfViewerFileName = fileName
      this.pdfViewerUrl = url
      this.pdfViewerPopup = true
      $('body').addClass("pdf_view_actv")
    },
    noteViewShowMethod(data){
      this.notesViewData = data
      this.notesViewPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
  },
  watch:{
    getResearchGroupDetails(){
      return this.$store.getters.researchGroupDetails
    },
    setInitialsState(){
      if(this.researchGroupDetails){
        this.researchGroupInPapers = this.researchGroupDetails.pdf_papers
      }
      return;
    }
  },
  beforeCreate:function(){
    $('body').addClass('researchfile_body_wrp')
  },
  beforeRouteLeave: function(to, from, next) {
    if(to.name != 'paperPilesPreferences' && to.name != 'paperPiles' && to.name != 'bucketDetails'){
      $('body').removeClass('researchfile_body_wrp');
    }
    next();
  },
}